import React from 'react';
import { Plus } from 'lucide-react';
import { ScenarioCard } from './ScenarioCard';
import type { RateScenario } from '../../types';

interface Props {
  scenarios: RateScenario[];
  onChange: (scenarios: RateScenario[]) => void;
}

export function ScenarioList({ scenarios, onChange }: Props) {
  const addScenario = () => {
    if (scenarios.length >= 5) return;
    onChange([
      ...scenarios,
      {
        id: crypto.randomUUID(),
        name: `Scenario ${scenarios.length + 1}`,
        paymentFixedFee: 0,
        paymentRatePercent: 0,
        payoutFixedFee: 0,
        payoutRatePercent: 0,
      },
    ]);
  };

  const updateScenario = (index: number, updated: RateScenario) => {
    const next = [...scenarios];
    next[index] = updated;
    onChange(next);
  };

  const deleteScenario = (index: number) => {
    onChange(scenarios.filter((_, i) => i !== index));
  };

  return (
    <div>
      <div className="flex items-center justify-between mb-3">
        <h3 className="text-lg font-medium text-gray-900">
          Rate Scenarios ({scenarios.length}/5)
        </h3>
        <button
          onClick={addScenario}
          disabled={scenarios.length >= 5}
          className="inline-flex items-center px-3 py-1.5 text-sm font-medium rounded-md text-indigo-600 bg-indigo-50 hover:bg-indigo-100 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          <Plus className="w-4 h-4 mr-1" />
          Add Scenario
        </button>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
        {scenarios.map((sc, i) => (
          <ScenarioCard
            key={sc.id}
            scenario={sc}
            index={i}
            canDelete={scenarios.length > 1}
            onChange={(updated) => updateScenario(i, updated)}
            onDelete={() => deleteScenario(i)}
          />
        ))}
      </div>
    </div>
  );
}
